module.exports = __webpack_public_path__ + "static/media/z-class@2x.aa9d8525.png";